// The type only decides the icon and label now - color encodes discussion STATE
// (see discussionStateColors.js), not type. Icon/label stay neutral gray.
export const DISCUSSION_TYPE_META = {
  classroom: {
    icon: 'chat-speech-balloon',
    labelKey: 'discussions.type.classroom'
  },
  content: {
    icon: 'workspace',
    labelKey: 'discussions.type.content'
  }
};

export const DISCUSSION_TYPE_NEUTRAL = {
  textColor: '#666',
  iconColor: '#8a8a90'
};

export const getDiscussionTypeMeta = discussion =>
  discussion.activityContext ? DISCUSSION_TYPE_META.content : DISCUSSION_TYPE_META.classroom;

// Help steps and empty states: the first step of each role is highlighted, the rest stay neutral.
export const DISCUSSION_HELP_COLORS = {
  accent: { background: '#E4F5FC', icon: '#12ABE3' },
  neutral: { background: '#ececf0', icon: '#666' },
  scheduled: { background: '#fffae4', icon: '#b38f10' }
};

export const DISCUSSION_TAB_EMPTY_META = {
  IN_PROGRESS: { icon: 'chat-speech-balloon', colors: DISCUSSION_HELP_COLORS.neutral },
  FINISHED: { icon: 'finish-flag', colors: DISCUSSION_HELP_COLORS.neutral },
  FUTURE: { icon: 'office-monthly-calendar', colors: DISCUSSION_HELP_COLORS.scheduled }
};
